import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AxeIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="currentColor"
    title={t`Axe`}
    {...props}
  >
    <Path
      d="M6.17831 0.89172L9.60575 3.35581L15 4.1467L9.86075 11.6835L7 7L3.60868 4.6601L6.17831 0.89172Z"
      fill="currentColor"
    />
    <Path
      d="M5.00085 6.67909L6.61461 7.77946L1.61376 15.1133L0 14.0129L5.00085 6.67909Z"
      fill="currentColor"
    />
    <Path
      d="M9.60575 0L11.2195 1.10037L10.3728 2.26925L8.75908 1.16888L9.60575 0Z"
      fill="currentColor"
    />
  </Icon>
);
